import { render, staticRenderFns } from "./SmsList.vue?vue&type=template&id=3ee2bc54&scoped=true"
import script from "./SmsList.vue?vue&type=script&lang=js"
export * from "./SmsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee2bc54",
  null
  
)

export default component.exports